import type { BasicListOption } from '../../GenericBloc/GenericLargeListFilter/GenericLargeListType';
import { RadioTextFilterOperation } from '../../GenericBloc/GenericRadioTextFilter/GenericRadioTextType';
import { URL_PLACEHOLDERS } from '../../GenericConstants/GenericOperationPlaceholders';
import { ClickedOperation, SubFilterClickedKind } from '../ClickedFilterType';

export const OCCURRED_OPTION_LIST: BasicListOption<ClickedOperation>[] = [
  { value: ClickedOperation.OCCURRED, label: 'occurred' },
  { value: ClickedOperation.DID_NOT_OCCUR, label: 'did not occur' },
];

export const SUB_FILTER_KIND_OPTION_LIST: BasicListOption<SubFilterClickedKind>[] = [
  { value: SubFilterClickedKind.TEXT, label: 'button or link text' },
  { value: SubFilterClickedKind.SELECTOR, label: 'CSS selector' },
  { value: SubFilterClickedKind.PAGE_PATH, label: 'page URL' },
];

const TEXT_PLACEHOLDERS = {
  [RadioTextFilterOperation.CONTAINS]: 'e.g. Add to cart',
  [RadioTextFilterOperation.IS]: 'e.g. Add to cart',
  [RadioTextFilterOperation.IS_NOT]: 'e.g. Add to cart',
  [RadioTextFilterOperation.NOT_CONTAINS]: 'e.g. Add to cart',
};

const CSS_SELECTOR_PLACEHOLDERS = {
  [RadioTextFilterOperation.CONTAINS]: 'e.g. div.col-sm-3>button',
  [RadioTextFilterOperation.IS]: 'e.g. div.col-sm-3>button',
  [RadioTextFilterOperation.IS_NOT]: 'e.g. div.col-sm-3>button',
  [RadioTextFilterOperation.NOT_CONTAINS]: 'e.g. div.col-sm-3>button',
};

export const PLACEHOLDER_BY_TYPE = {
  [SubFilterClickedKind.PAGE_PATH]: URL_PLACEHOLDERS,
  [SubFilterClickedKind.SELECTOR]: CSS_SELECTOR_PLACEHOLDERS,
  [SubFilterClickedKind.TEXT]: TEXT_PLACEHOLDERS,
};

export const COLUMN_ONE_WIDTH = 272;

export const COLUMN_TWO_WIDTH = 164;
